module.exports = __webpack_public_path__ + "img/ticket_w.e1a9b73a.svg";